module.exports = __webpack_public_path__ + "static/media/sortDesc.2bae501f.svg";